import React, { Component } from "react";
import Counter from "../Counter/Counter";
import { convertCurrency, formatNumberWithSpaces } from "../../utils";
import {
  getBeneficiariesList,
  getCustomerDetail,
  disableCardNumber,
  getCartTotal,
} from "../../api";
import CardDetail from "../CardDetail/CardDetail";
import "./Card.scss";
import CartPopup from "../CartPopup/CartPopup";
import { config, MAX_AMOUNT } from "../../Constants";
import ReusablePopup from "../ReusablePopup/ReusablePopup";

export class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: props.product,
      price: 0,
      rechargeValue:
        props.product.id == process.env.REACT_APP_CARD_GIFT_ID ? 100 : 30,
      customer: null,
      beneficiaries: [],
      open: false,
      quantity: 0,
      desactive: true,
      isReusablePopupOpen : false,
    };
  }

  componentDidMount() {
    getBeneficiariesList().then((beneficiaries) => {
      if (beneficiaries.length > 0) {
        beneficiaries = beneficiaries.map((obj) => ({
          ...obj,
          readOnly: true,
          selected: false,
        }));
        this.setState({ beneficiaries });
      }
    });

    getCustomerDetail().then((customer) =>
      this.setState({ customer }, () => this.handlePriceChange())
    );
  }

  handleChange(e, isString = false) {
    if (!isNaN(parseInt(e.target.value)) || isString) {
      this.setState(
        {
          [e.target.name]: [e.target.value],
        },
        () => {
          this.handlePriceChange();
        }
      );
    }
  }

  setDesactive() {
    let desactive = this.state.desactive;
    this.setState({ desactive: !desactive });
  }

  addBeneficiaries(e, index) {
    const { name, value } = e.target;
    const list = [
      ...this.state.beneficiaries.filter(
        (beneficiary) => beneficiary.status == "1"
      ),
    ];
    list[index]["error"] = false;

    if (name === "cardNumber") {
      list[index]["errorCard"] = "";
      if (
        !value ||
        this.state.beneficiaries.some(
          (beneficiary) => value === beneficiary.cardNumber
        )
      ) {
        list[index]["errorCard"] = "Votre ID doit etre unique";
      }
      list[index][name] = value;
    } else if (name === "cardName") {
      list[index]["errorName"] = "";
      if (value === "") {
        list[index]["errorName"] = "Votre nom ne doit pas etre vide";
      }
      list[index][name] = value;
    } else if (name === "phoneNumber") {
      list[index]["errorPhone"] = "";
      if (
        this.state.beneficiaries.some(
          (beneficiary) => value === beneficiary.phoneNumber
        ) ||
        value.length !== 9
      ) {
        list[index]["errorPhone"] =
          "Votre numéro de téléphone doit etre valide et unique";
      }
      list[index][name] = value;
    } else {
      list[index][name] = value;
      list[index]["errorName"] = "";
      list[index]["errorCard"] = "";
      list[index]["errorPhone"] = "";
    }
    this.setState({
      beneficiaries: [
        ...this.state.beneficiaries.filter(
          (beneficiary) => beneficiary.status !== "1"
        ),
        ...list,
      ],
    });
  }

  addNewBeneficiary() {
    const { beneficiaries } = this.state;
    const newBeneficiaries = [
      ...beneficiaries,
      {
        cardName: "",
        cardNumber: "",
        phoneNumber: "",
        status: "1",
        selected: true,
        error: true,
      },
    ];

    this.setState({ beneficiaries: newBeneficiaries, desactive: true }, () =>
      this.handlePriceChange()
    );
  }

  removeNewBeneficiary(e, index) {
    const list = [
      ...this.state.beneficiaries.filter(
        (beneficiary) => beneficiary.status == "1"
      ),
    ];
    list[index].selected = false;
    list.splice(index, 1);
    this.setState(
      {
        beneficiaries: [
          ...this.state.beneficiaries.filter(
            (beneficiary) => beneficiary.status != "1"
          ),
          ...list,
        ],
      },
      this.handlePriceChange()
    );
  }

  disableBeneficiaries = async (e, filteredIndex) => {
    const { beneficiaries, desactive } = this.state;

    const filteredBeneficiaries = beneficiaries.filter(
      (beneficiary) => beneficiary.status === (+desactive).toString()
    );
    const beneficiary = filteredBeneficiaries[filteredIndex];

    if (beneficiary && beneficiary.readOnly) {
      try {
        const res = await disableCardNumber({
          cardNumber: beneficiary.cardNumber,
          status: (+!desactive).toString(),
        });

        if (res.success) {
          this.setState(
            (prevState) => ({
              beneficiaries: prevState.beneficiaries.map((b, i) =>
                b === beneficiary
                  ? { ...b, status: (+!desactive).toString(), selected: false }
                  : b
              ),
            }),
            () => {
              this.handlePriceChange();
            }
          );
        } else {
          alert("Réessayer plus tard");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Une erreur est survenue. Veuillez réessayer plus tard.");
      }
    }
  };

  selectBeneficiaries = (e, index) => {
    const { checked } = e.target;
    const { beneficiaries } = this.state;

    const statusOneBeneficiaries = beneficiaries.filter(
      (beneficiary) => beneficiary.status === "1"
    );

    if (index >= 0 && index < statusOneBeneficiaries.length) {
      const updatedBeneficiaries = [...beneficiaries];

      const indexOfBeneficiary = beneficiaries.indexOf(
        statusOneBeneficiaries[index]
      );
      updatedBeneficiaries[indexOfBeneficiary].selected = checked;
      updatedBeneficiaries[indexOfBeneficiary].error =
        checked &&
        (updatedBeneficiaries[indexOfBeneficiary].cardNumber === "" ||
          updatedBeneficiaries[indexOfBeneficiary].cardName === "" ||
          updatedBeneficiaries[indexOfBeneficiary].phoneNumber === "");

      this.setState({ beneficiaries: updatedBeneficiaries }, () => {
        this.handlePriceChange();
      });
    }
  };

  selectAllBeneficiaries() {
    const filteredBeneficiaries = this.state.beneficiaries.filter(
      (beneficiary) => beneficiary.status === "1"
    );

    const updatedBeneficiaries = filteredBeneficiaries.map((beneficiary) => ({
      ...beneficiary,
      selected: true,
    }));
    this.setState(
      {
        beneficiaries: [
          ...this.state.beneficiaries.filter(
            (beneficiary) => beneficiary.status !== "1"
          ),
          ...updatedBeneficiaries,
        ],
      },
      () => {
        this.handlePriceChange();
      }
    );
  }

  handlePriceChange() {
    let { beneficiaries, rechargeValue } = this.state;
    beneficiaries = beneficiaries.filter((beneficiary) => beneficiary.selected);
    this.setState({
      price: rechargeValue * beneficiaries.length,
      quantity: beneficiaries.length,
    });
  }

  /*checkCIN(arr) {
    return arr.some(
      (beneficiary) =>
        beneficiary.cardNumber.length !== 8
    );
  } */
  checkCardNumber(arr) {
    return arr.some((beneficiary) => !beneficiary.cardNumber);
  }
  /* checkPhone(arr) {
    return arr.some(
      (beneficiary) =>
      !/^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/.test(beneficiary.cardNumber.replace(/\s/g,''))
    );

  } */
  checkPhone(arr) {
    return arr.some((beneficiary) => beneficiary.phoneNumber.length !== 9);
  }

  emptyFields(arr) {
    return arr.some(
      (beneficiary) =>
        beneficiary.cardName === "" ||
        beneficiary.cardNumber === "" ||
        beneficiary.phoneNumber === ""
    );
  }

  setOpen() {
    this.setState({ open: !this.state.open });
  }
  setIsReusablePopupOpen(open=true) {
    this.setState({ isReusablePopupOpen: open });
  }

  checkName(arr) {
    let pattern = /^([ \u00c0-\u01ffa-zA-Z'-])+$/;

    return arr.some((beneficiary) => beneficiary.cardName.match(pattern));
  }

  async addToCart() {
    let { rechargeValue, beneficiaries, price, product } = this.state;
    beneficiaries = beneficiaries.filter((beneficiary) => beneficiary.selected);
    if (beneficiaries.length === 0) {
      alert("Merci de selectionner au moin 1 beneficiare");
      return false;
    }
    if (this.emptyFields(beneficiaries)) {
      alert("Merci de renseigner tous les champs");
      return false;
    }

    if (!this.checkName(beneficiaries)) {
      alert("Votre nom doit contenir seulement des alphabets");
      return false;
    }
    if (this.checkCardNumber(beneficiaries)) {
      alert("votre ID doit etre valide ");
      return false;
    }
    if (this.checkPhone(beneficiaries)) {
      alert("votre Numéro de téléphone doit etre valide");
      return false;
    }

    const addUrl =
      document.getElementById("add-to-cart-or-refresh")?.value ||
      `${config.url}/panier`;
    const token =
      process.env.REACT_APP_STAGE === "dev"
        ? "6201c3c0310244f2bcffdda74673397a"
        : document.getElementsByName("token")[0].value;

    const data = new FormData();
    data.append("token", token);
    data.append("id_product", product.id);
    data.append("value", rechargeValue);
    data.append("qty", beneficiaries.length);
    data.append("beneficiaries", JSON.stringify(beneficiaries));
    data.append("total", price);
    data.append("add", 1);
    data.append("action", "update");

    const postToCart = async () => {
      const response = await fetch(addUrl, {
        method: "POST",
        mode: "cors",
        body: data,
      });
      return response;
    };
    const getCurrentCartTotal = async () => {
      const cart = window.prestashop?.cart?.totals?.total;
      if (cart && cart.amount) {
        return +cart.amount; 
      }
  
      try {
        const data = await getCartTotal(); 
        return data || 0; 
      } catch (error) {
        console.error("Failed to fetch cart total:", error);
        return 0; 
      }
    };
    const currentCartTotal = await getCurrentCartTotal();
    if (currentCartTotal + price > MAX_AMOUNT) {
      this.setIsReusablePopupOpen(true);
      return;
    } 

    postToCart().then( (resp)=>window.prestashop.emit('updateCart', {
      reason: {}, resp: resp,
    })).then(res=>this.setOpen());  
  }

  render() {
    const { product, price, beneficiaries, desactive, rechargeValue } =
      this.state;
    const id = product.id;
    let counter;
    if (id == process.env.REACT_APP_CARD_GIFT_ID) {
      counter = (
        <Counter
          name="rechargeValue"
          value={rechargeValue}
          min={2}
          max={Infinity}
          step={0.5}
          stepInput={1}
          onValueChange={(e) => this.handleChange(e)}
        />
      );
    } else {
      counter = (
        <Counter
          name="rechargeValue"
          value={rechargeValue}
          min={2}
          max={Infinity}
          step={0.5}
          stepInput={1}
          onValueChange={(e) => this.handleChange(e)}
        />
      );
    }
    return (
      <div className="Card">
        <h1>{product.name}</h1>
        <p className="desc">
          {product.description_short.replace(/<[^>]*>?/gm, "")}
        </p>
        <p className="price">{convertCurrency(price)}</p>
        <div className="beneficiaries">
          <div id="label_beneficiaires">
            <label htmlFor="couponName">Selectionnez les bénéficiaires :</label>
          </div>
          <div
            style={{
              flexFlow: "row",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
            className="add_ben input-group"
          >
            <button
              className="button-round white same-line"
              onClick={() => this.selectAllBeneficiaries()}
            >
              <span>+</span> Tout selectionner
            </button>
            <button
              className="button-round white same-line"
              style={{ marginRight: "10px" }}
              onClick={() => this.addNewBeneficiary()}
            >
              <span>+</span> Ajouter nouveau bénéficiaires
            </button>
            <button
              className="button-round white same-line"
              onClick={() => this.setDesactive()}
            >
              {desactive ? (
                <span>bénéficiaires désactivés</span>
              ) : (
                <span>bénéficiaires activés</span>
              )}
            </button>
          </div>
          {beneficiaries
            .filter(
              (beneficiary) => beneficiary.status === (+desactive).toString()
            )
            .map((value, index) => {
              return (
                <CardDetail
                  value={value}
                  key={index}
                  index={index}
                  uid={value.cardNumber}
                  desactive={desactive}
                  handleChange={(e, i) => this.addBeneficiaries(e, i)}
                  handleRemove={(e, i) => this.removeNewBeneficiary(e, i)}
                  handleSelect={(e, i) => this.selectBeneficiaries(e, i)}
                  handleDisable={(e, i) => this.disableBeneficiaries(e, i)}
                />
              );
            })}
        </div>
        <div id="valeur_recharge" className="input-group">
          <div id="label_valeur_recharge" className="label">
            <label htmlFor="rechargeValue">Valeur de la recharge :</label>
          </div>
          <div className="counter-container">{counter}</div>
        </div>
        <div className="product-add-to-cart">
          <div className="add green_btn">
            <button type="submit" onClick={() => this.addToCart()}>
              Commander
            </button>
          </div>
        </div>
        <CartPopup
          Produit={this.state.product}
          Price={this.state.price}
          Quantity={this.state.quantity}
          setOpen={() => this.setOpen()}
          open={this.state.open}
        />
        <ReusablePopup
        isOpen={this.state.isReusablePopupOpen}
        onClose={() => this.setIsReusablePopupOpen(false)}
        title="Limite du panier dépassée"
        message={
          <>
            Merci de contacter le service client ou le service commercial au{" "}
            <a href="tel:+212520012121" style={{ color: "blue", textDecoration: "underline" }}>
              [+212 520-012121]
            </a>.
          </>
        }
        actions={<button className="green_btn" onClick={() => this.setIsReusablePopupOpen(false)}>Fermer</button>}
      />
      </div>
    );
  }
}

export default Card;
